<template>
  <div class="main-layout" style="width:100%;float:left;">
    <admin-navbar v-if="user && user.admin"></admin-navbar>
    <navbar/>

    <div class="mt-4" style="width:100%;float:left;">
      <child/>
    </div>

    <!-- <div id="overlay">
      <div style="width:100%;height:200px;margin-top:calc((100vh - 200px) / 2);">
        <h1>UNDER CONSTRUCTION</h1>
        <h4>We are finishing up some upgrades....</h4>
        <h3>Be back Monday!</h3>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '~/components/Navbar'
import AdminNavbar from '~/components/admin_navbar'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    AdminNavbar
  },
  computed: mapGetters({
    user: 'auth/user'
  })
}
</script>
<style src="@fortawesome/fontawesome-free/css/all.css"></style>
<style lang="scss" scoped>

#overlay {
  position:fixed;
  top:0;left:0;right:0;bottom:0;
  width:100%;
  height:100%;
  background-image:linear-gradient(to bottom right, #1d76a5, #1d44a5);
  /*background:rgba(0,0,0,1);*/
  color:#fff;
  text-align:center;
  font-size:35px;
  z-index:100000;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue